import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Flex } from "@radix-ui/themes";
import { useStore } from '../store/store';

export const NavigationHeader = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [state, actions] = useStore();
    
    // Determine breadcrumbs based on current route
    const breadcrumbs = useMemo(() => {
        const path = location.pathname;
        const items = [];
        
        // Don't show breadcrumbs on dashboard
        if (path === '/dashboard') {
            return items;
        }
        
        // Extract parameters from URL path
        const novelMatch = path.match(/\/novel\/([^\/]+)/);
        const chapterMatch = path.match(/\/chapter\/([^\/]+)/);
        const sceneMatch = path.match(/\/scene\/([^\/]+)/);
        
        const novelId = novelMatch ? novelMatch[1] : null;
        const chapterId = chapterMatch ? chapterMatch[1] : null;
        const sceneId = sceneMatch ? sceneMatch[1] : null;
        
        // Add Dashboard link for all other pages
        items.push({
            label: 'Dashboard',
            path: '/dashboard',
            onClick: () => navigate('/dashboard')
        });
        
        // Add Novel link for novel-related pages
        if (novelId) {
            items.push({
                label: 'Chapter Overview',
                path: `/novel/${novelId}`,
                onClick: () => navigate(`/novel/${novelId}`)
            });
        }

        if (chapterId) {
            const currentChapter = state.currentNovel?.chapters.find(chapter => chapter.id === chapterId);
            items.push({
                label: 'Chapter ' + currentChapter?.chapter_number,
                path: `/novel/${novelId}/chapter/${chapterId}`,
                onClick: () => navigate(`/novel/${novelId}/chapter/${chapterId}`)
            });
        }

        if (sceneId) {
            const currentChapter = state.currentNovel?.chapters.find(chapter => chapter.id === chapterId);
            const currentScene = currentChapter?.scenes?.find(scene => scene.id === sceneId);
            items.push({
                label: 'Scene ' + currentScene?.scene_number,
                path: '',
                onClick: () => console.log('Scene clicked')
            });
        }


        return items;
    }, [location.pathname, navigate]);
    
    // If no breadcrumbs, don't render the component
    if (breadcrumbs.length === 0) {
        return null;
    }
    
    return (
        <Flex 
            as="nav" 
            aria-label="Breadcrumb"
            align="center"
            padding="8px 16px"
            style={{ marginLeft: '25%', position: 'relative', zIndex: 1 }}
        >
            {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={crumb.path}>
                    <span 
                        className="breadcrumb-item"
                        onClick={crumb.onClick}
                    >
                        {crumb.label}
                    </span>
                    
                    {index < breadcrumbs.length - 1 && (
                        <span className="breadcrumb-separator" style={{ margin: '0 8px' }}>
                            /
                        </span>
                    )}
                </React.Fragment>
            ))}
        </Flex>
    );
};

export default NavigationHeader;